module.exports = __webpack_public_path__ + "img/QRCode.c1b3da6d.png";